"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BindSupplier = _interopRequireDefault(require("../dialogs/BindSupplier.vue"));
var _api = require("../../../api");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Supplier',
  components: {
    BindSupplierVue: _BindSupplier.default
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  data: function data() {
    return {
      bindSupplierVueRef: null,
      tableData: {
        list: []
      }
    };
  },
  methods: {
    openSupplier: function openSupplier(row) {
      this.bindSupplierVueRef.open(row);
    },
    getSuppliers: function getSuppliers() {
      var _this = this;
      (0, _api.customerSuppliersApi)(this.id).then(function (res) {
        _this.tableData = res || {
          list: []
        };
      });
    },
    deleteRecord: function deleteRecord(row) {
      var _this2 = this;
      (0, _api.deleteSupplierApi)(row).then(function () {
        _this2.$message.success('移除成功');
        _this2.getSuppliers();
      });
    }
  },
  mounted: function mounted() {
    this.bindSupplierVueRef = this.$refs.bindSupplierVueRef;
    this.getSuppliers();
  },
  watch: {
    id: function id(newVal) {
      if (newVal) {
        this.getSuppliers();
      }
    }
  }
};